import { render, staticRenderFns } from "./AddServiceDialog.vue?vue&type=template&id=2cfdd11f&scoped=true&"
import script from "./AddServiceDialog.vue?vue&type=script&lang=js&"
export * from "./AddServiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddServiceDialog.vue?vue&type=style&index=0&id=2cfdd11f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfdd11f",
  null
  
)

export default component.exports